import mixins from 'vue-typed-mixins';

import PlbscfTable from '@/components/plbscfTable/PlbscfTable.vue';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 計画PlbscfMixin from '@/entries/user/mixins/計画PlbscfMixin';

import { PlbscfTypeList } from '@/classes/service/AbstractPlbscfService';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(RoutesMixin, 計画PlbscfMixin).extend({
  name: 'P計画変動損益',

  components: {
    PlbscfTable,
  },

  data(): {
    tabTypes: PlbscfType[];
  } {
    return {
      tabTypes: [PlbscfType.変動損益, PlbscfType.運転資金, PlbscfType.FCF],
    };
  },

  computed: {
    plbscfTypeList(): PlbscfTypeList | undefined {
      return this.計画Plbscf.types.find((typeList) => typeList.type === this.tabType);
    },
  },

  methods: {
    reload(): void {
      if (!confirm('更新しますか？')) return;
      this.load();
    },
    onChangeフリーキャッシュフロー種別(): void {
      // 再計算
      this.計画Plbscf = this.service.calcAndCreate計画Plbscf();
      this.initializeFlag();
    },
  },
});
